import { cn } from "@reactive-resume/utils";

import { SecAIChat } from "../sections/sec-ai-chart";

const ContainerAIChat = (props: { isOpen: boolean; onClose: () => void }) => {
  const { isOpen, onClose } = props;
  return (
    <div
      className={cn(
        "box-border flex h-full max-h-screen flex-1 flex-col gap-y-6 p-6 pb-16 @container/right lg:pb-0",
        isOpen ? "" : "hidden",
      )}
    >
      <SecAIChat onClose={onClose} />
    </div>
  );
};

export default ContainerAIChat;
